import React, { useRef } from 'react';
import { ArrowLeft, Calendar, Pencil, Info } from 'lucide-react';
import CustomDataGrid from '../../../components/common/CustomDataGrid/CustomDataGrid';
import { useNavigate } from 'react-router-dom';
import InfoCard from '../common/InfoCard';

import { useFormik } from "formik";
import * as Yup from "yup";
import CustomDatePicker from '../../../components/common/CustomDatePicker/CustomDatePicker';
import { useState } from 'react';
import { Formik, Form } from 'formik';

const columns = [
  {
    field: 'leadName',
    headerName: 'Lead Name',
    width: '200px',
    renderCell: (row) => (
      <div className="flex items-center gap-2">
        {row.leadName}
        <Info className="w-4 h-4 text-gray-400" />
      </div>
    ),
  },
  {
    field: 'advisorName',
    headerName: 'Advisor Name',
    width: '200px',
    renderCell: (row) => (
      <div className="flex items-center gap-2">
        {row.advisorName}
        <Info className="w-4 h-4 text-gray-400" />
      </div>
    ),
  },
  {
    field: 'product',
    headerName: 'Product',
    width: '200px',
    renderCell: (row) => (
      <div className="flex items-center gap-2">
        {row.product}
        <Info className="w-4 h-4 text-gray-400" />
      </div>
    ),
  },
  {
    field: 'policyAmount',
    headerName: 'Policy Amount',
    width: '150px',
  },
  {
    field: 'commission',
    headerName: 'Commission',
    width: '150px',
  },
  {
    field: 'lastPaymentDate',
    headerName: 'Last Payment Date',
    width: '161px',
    renderCell: (row) => (
      <div className="flex items-center gap-2">
        {row.lastPaymentDate}
        <Info className="w-4 h-4 text-gray-400" />
      </div>
    ),
  },
];
const data = [
  {
    id: 1,
    leadName: 'Sidharth Malviya',
    advisorName: 'Sidharth Malviya',
    product: 'Term Life Insurance',
    policyAmount: '₹12 Lakhs',
    commission: '₹20,000',
    lastPaymentDate: '12 Jan 2025',
  },
  {
    id: 2,
    leadName: 'Arjun Sehgal',
    advisorName: 'Arjun Sehgal',
    product: 'Systematic Investment Plans',
    policyAmount: '₹50 Lakhs',
    commission: '₹15,000',
    lastPaymentDate: '12 Jan 2025',
  },
  {
    id: 3,
    leadName: 'Virat Kumar',
    advisorName: 'Virat Kumar',
    product: 'Whole Life Insurance',
    policyAmount: '₹80 Lakhs',
    commission: '₹40,000',
    lastPaymentDate: '12 Jan 2025',
  },
  {
    id: 4,
    leadName: 'Vikas Mahatre',
    advisorName: 'Vikas Mahatre',
    product: 'Critical Illness Insurance',
    policyAmount: '₹12 Lakhs',
    commission: '₹5,000',
    lastPaymentDate: '12 Jan 2025',
  },
  {
    id: 5,
    leadName: 'Sidharth Malviya',
    advisorName: 'Sidharth Malviya',
    product: 'Car Insurance',
    policyAmount: '₹5,000',
    commission: '₹1,000',
    lastPaymentDate: '12 Jan 2025',
  },
  {
    id: 6,
    leadName: 'Arjun Sehgal',
    advisorName: 'Arjun Sehgal',
    product: 'Home Insurance',
    policyAmount: '₹3,000',
    commission: '₹800',
    lastPaymentDate: '12 Jan 2025',
  },
];
const StatCard = ({ title, value }) => (
  <div className="bg-white rounded-xl border border-gray-100 hover:border-gray-200 transition-colors p-5">
    <p className="text-sm font-medium text-ink-muted mb-2">{title}</p>
    <p className="text-2xl font-semibold text-ink truncate">{value}</p>
  </div>
);

const CompanyDetail = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-page-bg p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center gap-4">
            <button className="p-2 border rounded-md" onClick={() => { navigate("/partner") }}>
              <ArrowLeft className="w-5 h-5" />
            </button>
            <h1 className="text-2xl leading-7 font-bold text-ink">Company Detail</h1>
          </div>
          <div className="flex items-center gap-4">
            
              <Formik initialValues={{ date: "" }} onSubmit={() => {}}>
                {() => (
                  <Form>
                    <CustomDatePicker name="date" label="" placeholder='Select Dates' />
                 
                  </Form>
                )}
              </Formik>

          
          </div>
        </div>
        {/* Company Info */}
        <div className="bg-white rounded-xl border border-gray-100 p-6 mb-8">
          <div className="flex justify-between items-start">
            <div className="flex gap-6">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSRWUIxNytsPAyUzmLDKxq6nOwo3cnmcFJMAQ&s"
                alt="ICICI"
                className="w-16 h-16 object-contain"
              />
              <div>
                <h2 className="text-xl font-semibold text-gray-900">ICICI</h2>
                <p className="text-gray-500 mt-1">Lorem Ipsum</p>
                <div className="grid grid-cols-3 gap-12 mt-4">
                  <div className='text-left mr-auto'>
                    <span className="text-gray-500">Company Name :</span>
                    <span className="text-gray-900 ml-2">ICICI</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Email :</span>
                    <span className="text-gray-900 ml-2">sidharth12@gmail.com</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Mobile :</span>
                    <span className="text-gray-900 ml-2">9876543212</span>
                  </div>
                </div>
              </div>
            </div>
            <button className="flex items-center gap-2 text-primary px-4 py-2 rounded-lg hover:bg-primary-light">
              <Pencil className="w-4 h-4" />
              <span>Edit</span>
            </button>
          </div>
        </div>
        {/* Stats Grid */}
        <div className="grid grid-cols-5 gap-6 mb-8">
          <StatCard title="No. Of Products" value="12" />
          <StatCard title="Converted Leads" value="24" />
          <StatCard title="Total Earnings" value="₹70,000" />
          <StatCard title="Received Earnings" value="₹34,000" />
          <StatCard title="Pending Earnings" value="₹36,000" />
        </div>
        {/* Data Grid */}
        <CustomDataGrid
          columns={columns}
          rows={data}
          keyId="id"
          perPageSize={10}
          showPagination={true}
        />
      </div>
    </div>
  )
}

export default CompanyDetail

